import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Progress } from "react-sweet-progress";
import statelist from "../../assets/Json/statedistrict.json";
import { useNavigate } from "react-router-dom";
import { Table, Tab, Tabs, Form,Pagination } from "react-bootstrap";

function ValidatorView() {
  const navigate = useNavigate();
  const [key, setKey] = useState("pending");
  const [response, setResponse] = useState([]);
  const [shortresponse, setshortResponse] = useState([]);
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [StKey, setStKey] = useState("");
  const [content, setContent] = useState(0);
  const [creativity, setCreativity] = useState(0);
  const [discription, setDiscription] = useState("");
  const [enthusiasm, setEnthusiasm] = useState(0);
  const [emotionalStability, setEmotionalStability] = useState(0);
  const [comprehansiveAbility, setComprehansiveAbility] = useState(0);

  
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setPostPerPage] = useState(2);
  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = shortresponse?.slice(firstPostIndex, lastPostIndex);
  const r_post=response?.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(shortresponse?.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];

  let totalCount =
    parseInt(content) +
    parseInt(creativity) +
    parseInt(enthusiasm) +
    parseInt(emotionalStability) +
    parseInt(comprehansiveAbility);
  let manualScore = totalCount / 5;

  useEffect(() => {
    let userdata = JSON.parse(localStorage.getItem("user"));
    if (!userdata.role === "admin") {
      navigate("/face-analyser/login");
    }
    let user = JSON.parse(localStorage.getItem('user'))
    setState(user.state);
    setDistrict(user.district);
    let token = localStorage.getItem("token");
    let stat = 'new'
    axios
    .get(
      `https://anuvadiniqa.aicte-india.org/face/fetch_all_vid?state=${user.state}&district=${user.district}&status=${stat}`,
      {
        headers: {
          Authorization: `Bearer ${
            token
              ? token
              : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoidGVzdCIsInVzZXJOYW1lIjoidGVzdEBnbWFpbC5jb20iLCJyb2xlIjoidmFsaWRhdG9yIiwiaWF0IjoxNjkyNDI2MjczLCJleHAiOjE2OTI1MTI2NzN9.Gy3Mm-7cfHCfG1r2N5DuUWSzGbBbGPJEmibC0IWwLYU"
          }`,
        },
      }
    )
    .then((res) => {
      if (res.data.status == "success") {
        let data = res.data.data;
        console.log(data.videos)
        setResponse(data.videos);
      }
    })
    .catch((err) => {
      console.log(err, `error`);
    });
  axios
    .get(
      `https://anuvadiniqa.aicte-india.org/face/fetch_validated_vid?state=${user.state}&district=${user.district}`,
      {
        headers: {
          Authorization: `Bearer ${
            token
              ? token
              : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoidml2IiwidXNlck5hbWUiOiJ2aXZAbWFpbC5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2OTIyNDY2MjMsImV4cCI6MTY5MjMzMzAyM30.6ZtdqhqwpC4mqpvlwOncDonz_GHLoUumUy8k9dDxVSs"
          }`,
        },
      }
    )
    .then((res) => {
      if (res.data.status == "success") {
        let data = res.data.data;
        console.log(data.videos)
        setshortResponse(data.videos);
      }
    });
    
  }, []);

  const handlestselect = (key) => {
    setStKey(key);
    setState(statelist.states[key].state);
  };

  const handleShortlist = (id) => {
    const post = { _id: id, status: "shorlisted" };
    axios
      .post("https://anuvadiniqa.aicte-india.org/face/set_shortlisted", post)
      .then((res) => {
        if (res.data.status == "success") {
          alert("sucessfully shortlisted");
        } else alert("something went wrong");
      })
      .catch((err) => {
        console.log("shortlist apii", err);
      });
  };

  const handleSubmit = (id, percent) => {
    let token = localStorage.getItem("token");
    let vall = {
        content: content,
        creativity:creativity,
        discription:discription,
        enthusiasm: enthusiasm,
        emotionalStability: emotionalStability,
        comprehansiveAbility: comprehansiveAbility




    }
    const post = {
      _id: id,
      percentage: percent,
      manualScore: manualScore,
      discription: discription,
      content: content,
      creativity:creativity,
      enthusiasm: enthusiasm,
      emotionalStability: emotionalStability,
      comprehansiveAbility: comprehansiveAbility
      
    };
    axios
      .post("https://anuvadiniqa.aicte-india.org/face/set_manualscore", post, {
        headers: {
          Authorization: `Bearer ${
            token
              ? token
              : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoidml2IiwidXNlck5hbWUiOiJ2aXZAbWFpbC5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2OTIyNDY2MjMsImV4cCI6MTY5MjMzMzAyM30.6ZtdqhqwpC4mqpvlwOncDonz_GHLoUumUy8k9dDxVSs"
          }`,
        },
      })
      .then((res) => {
        if (res.data.status == "success") {
          alert("Manual Score Submitted.");
          window.location.reload();
        } else alert("something went wrong");
      })
      .catch((err) => {
        console.log("shortlist apii", err);
      });
  };

  console.log("manual score", StKey);

  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li>
            <Link to="/face-analyser/">Home</Link>
          </li>
          <li>Video</li>
          <li>AI Video Analyzer</li>
        </ul>
        <div className="banner-content-sec text-center">
          <h1 className="first-head">PRERANA {StKey}</h1>
          <h3 className="second-head">
            School of Experiential Learning, A Mission to Inspire India
          </h3>
          <br />
        </div>
      </div>
      <main className="contentarea">
        <section className="vidpage">
          <div className="container">
            {/* <div className="selectstate d-flex justify-content-start text-start">
              <Form.Group className="mb-3 w-50">
                <Form.Label htmlFor="StateSelect">Select State</Form.Label>
                <Form.Select
                  id="StateSelect"
                  className="form-control"
                  onChange={(e) => handlestselect(e.target.value)}
                >
                  <option>Select State</option>
                  {statelist.states.map((index, key) => (
                    <>
                      <option value={key} selected={index.state==state}>{index.state}</option>
                    </>
                  ))}
                </Form.Select>
              </Form.Group>
              {StKey ? (
                <>
                  {" "}
                  <Form.Group className="mb-3 w-50 ml-3">
                    <Form.Label htmlFor="DistrictSelect">
                      Select District
                    </Form.Label>
                    <Form.Select
                      id="DistrictSelect"
                      className="form-control"
                      defaultValue={district}
                      onClick={(e) => setDistrict(e.target.value)}
                    >
                      <option>Select District</option>
                      {statelist.states[StKey].districts.map((index) => (
                        <>
                          <option value={index}>{index}</option>
                        </>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </>
              ) : (
                <>
                  {" "}
                  <Form.Group className="mb-3 w-50 ml-3">
                    <Form.Label htmlFor="DistrictSelect">
                      Select District
                    </Form.Label>
                    <Form.Select id="DistrictSelect" className="form-control">
                      <option>Select District</option>
                    </Form.Select>
                  </Form.Group>
                </>
              )}
            </div> */}
            <div> State : {state} & district : {district}</div>

            <div className="videoTab text-start">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="pending" title="pending">
                  <div className="tabDiv">
                    { response && r_post?.map((item, index) => {
                      return (
                        <>
                          <div className="tabDetail mt-4 d-flex justify-content-between align-items-center">
                            <div className="videos">
                              <video
                                width="320"
                                height="240"
                                src={item?.path+`?sp=r&st=2023-01-18T06:07:13Z&se=2028-12-31T14:07:13Z&spr=https&sv=2021-06-08&sr=c&sig=HtVlU%2BSsWizlSOrpTEIr40tfVncy74Og2N4VnG8cTH8%3D`}
                                controls
                              ></video>
                            </div>
                            <div className="tabledata">
                              <Table responsive className="text-start">
                                <tbody>
                                  <tr>
                                    <td>Unique ID</td>
                                    <td>{item.uniqueId}</td>
                                    <td>State</td>
                                    <td>{item.state}</td>
                                  </tr>
                                  <tr>
                                    <td>Student Name</td>
                                    <td>{item.name}</td>
                                    <td>District</td>
                                    <td>{item.district}</td>
                                  </tr>
                                  <tr>
                                    <td>Contact</td>
                                    <td>{item.contact}</td>
                                    <td>School Name</td>
                                    <td>{item.school}</td>
                                  </tr>
                                  <tr>
                                    <td>Email:</td>
                                    <td colSpan={3}>{item.email}</td>
                                  </tr>
                                  <tr>
                                    <td>Content (20%)</td>
                                    <td colSpan={3}>
                                      {" "}
                                      <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        onChange={(e) =>
                                          setContent(e.target.value)
                                        }
                                      />{" "}
                                    </td>
                                    <td>{content}%</td>
                                  </tr>
                                  <tr>
                                    <td>Creative Expression (20%)</td>
                                    <td colSpan={3}>
                                      {" "}
                                      <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        onChange={(e) =>
                                          setCreativity(e.target.value)
                                        }
                                      />
                                    </td>
                                    <td> {creativity}%</td>
                                  </tr>
                                  <tr>
                                    <td>Enthusiasm (20%)</td>
                                    <td colSpan={3}>
                                      {" "}
                                      <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        onChange={(e) =>
                                          setEnthusiasm(e.target.value)
                                        }
                                      />
                                    </td>
                                    <td> {enthusiasm}%</td>
                                  </tr>
                                  <tr>
                                    <td>Emotional Stability (20%)</td>
                                    <td colSpan={3}>
                                      {" "}
                                      <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        onChange={(e) =>
                                          setEmotionalStability(e.target.value)
                                        }
                                      />
                                    </td>
                                    <td>{emotionalStability}%</td>
                                  </tr>
                                  <tr>
                                    <td>Comprehansive Ability (20%)</td>
                                    <td colSpan={3}>
                                      {" "}
                                      <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        onChange={(e) =>
                                          setComprehansiveAbility(
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td> {comprehansiveAbility}%</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <Form.Label>
                                        Description {"(optional)"}
                                      </Form.Label>
                                    </td>
                                    <td colSpan={3}>
                                      {" "}
                                      <Form.Control
                                        as="textarea"
                                        rows={3}
                                        className="w-100"
                                        onChange={(e) =>
                                          setDiscription(e.target.value)
                                        }
                                      ></Form.Control>
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="totalScore">
                              <p>Confidence Score</p>
                              <h2>{manualScore} % </h2>
                              <div className="mt-5">
                                <button
                                  className="button green"
                                  onClick={(e) => {
                                    handleSubmit(
                                      item._id,
                                      Math.floor(item.percentage.percentage)
                                    );
                                  }}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                 {response ? (
                    <div className="d-flex justify-content-center">
                      <Pagination>
                        {page_arr.map((i, x) => (
                          <Pagination.Item
                            key={i}
                            onClick={() => {
                              setCurrentPage(i + 1);
                            }}
                            active={i + 1 === currentPage}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                      </Pagination>
                    </div>
                  ) : ( 
                    <></>
                  )}
                </Tab>
                <Tab eventKey="shortlist" title="Rated list">
                  <div className="tabDiv ">
                    { shortresponse && c_post?.map((item, index) => {
                      return (
                        <>
                          <div className="tabDetail mt-4 d-flex justify-content-between align-items-center">
                            <div className="videos">
                              <video
                                width="320"
                                height="240"
                                src={item?.path+`?sp=r&st=2023-01-18T06:07:13Z&se=2028-12-31T14:07:13Z&spr=https&sv=2021-06-08&sr=c&sig=HtVlU%2BSsWizlSOrpTEIr40tfVncy74Og2N4VnG8cTH8%3D`}
                                controls
                              ></video>
                            </div>
                            <div className="tabledata">
                              <Table responsive className="text-start">
                                <tbody>
                                  <tr>
                                    <td>Unique ID</td>
                                    <td>{item.uniqueId}</td>
                                    <td>State</td>
                                    <td>{item.state}</td>
                                  </tr>
                                  <tr>
                                    <td>Student Name</td>
                                    <td>{item.name}</td>
                                    <td>District</td>
                                    <td>{item.district}</td>
                                  </tr>
                                  <tr>
                                    <td>Contact</td>
                                    <td>{item.contact}</td>
                                    <td>School Name</td>
                                    <td>{item.school}</td>
                                  </tr>
                                  <tr>
                                    <td>Email:</td>
                                    <td colSpan={3}>{item.email}</td>
                                  </tr>
                                  {/* <tr>
                                                                        <td>Emotion</td>
                                                                        <td colSpan={3}>
                                                                            <ul>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="surprice">😲</span>{" "}
                                                                                    <Progress
                                                                                        percent={Math.floor(item.percentage.surprise)}
                                                                                    />
                                                                                </li>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="Happy">😁</span>{" "}
                                                                                    <Progress
                                                                                        percent={Math.floor(item.percentage.happy)}
                                                                                    />{" "}
                                                                                </li>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="Nutral">🙂</span>{" "}
                                                                                    <Progress
                                                                                        percent={(Math.floor(item.percentage.neutral))}
                                                                                    />{" "}
                                                                                </li>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="Sad">😔</span>{" "}
                                                                                    <Progress
                                                                                        percent={Math.floor(item.percentage.sad)}
                                                                                    />
                                                                                </li>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="angry">🥹</span>{" "}
                                                                                    <Progress
                                                                                        percent={Math.floor(item.percentage.angry)}
                                                                                    />
                                                                                </li>
                                                                                <li className="d-flex justify-content-between">
                                                                                    <span title="fear">😱</span>{" "}
                                                                                    <Progress
                                                                                        percent={Math.floor(item.percentage.fear)}
                                                                                    />
                                                                                </li>
                                                                            </ul>
                                                                        </td>
                                                                    </tr> */}
                                  <tr>
                                    <td>Note :</td>
                                    <td colSpan={3}>
                                      {item.discription
                                        ? item.discription
                                        : "no discription available"}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="totalScore">
                              <p>leacturer assigned Score</p>
                              <h2>{Math.floor(item.manualScore) + "%"}</h2>
                              {/* <div className="mt-5">
                                <input
                                  type="checkbox"
                                  className="formcontrol"
                                  id="select"
                                  checked={
                                    item.status == "shorlisted" ? true : false
                                  }
                                  onClick={() => handleShortlist(item._id)}
                                />
                                <label htmlFor="select">
                                  Select to Shortlist
                                </label>
                              </div> */}
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                  {shortresponse ? (
                    <div className="d-flex justify-content-center">
                      <Pagination>
                        {page_arr.map((i, x) => (
                          <Pagination.Item
                            key={i}
                            onClick={() => {
                              setCurrentPage(i + 1);
                            }}
                            active={i + 1 === currentPage}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}
                      </Pagination>
                    </div>
                  ) : ( 
                    <></>
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ValidatorView;
